import React, { useEffect, useState } from 'react'
import classNames from 'classnames'
import { useAppDispatch, useAppSelector } from '../../../../../store/hooks'
import { AiFeature } from '../../../../../models/AiFeature'
import { Col, Container, Row } from 'react-bootstrap'
import { useFormRerunHeaderResultOption } from './HeaderResultOptions'
import { HeaderResultOptionsButton } from '../MeetingResults/ResultCard/Header/HeaderResultOptions/HeaderResultOptionsButton'
import { selectAnonymousUsers, selectUsersWithClientRole } from '../../../../../store/meetingSummary/roomSession'
import { FormResultView } from './FormResultView'
import {
  formExecuteFinished,
  selectFormIsExecuting,
  selectFormIsPolling,
  selectFormScorecardForAiFeature,
  selectShouldPollFormResultsForAiFeatureId,
  startFormPolling,
  stopFormPolling,
} from '../../../../../store/meetingSummary/forms'
import { LoadingResult } from '../MeetingResults/ResultCard/Body/LoadingResult'

export interface FormViewProps {
  aiFeature: AiFeature
}

export const FormView: React.FC<FormViewProps> = ({ aiFeature }) => {
  const dispatch = useAppDispatch()

  const headerResultOptions = [useFormRerunHeaderResultOption(aiFeature)]
  const scorecard = useAppSelector((state) => selectFormScorecardForAiFeature(state, aiFeature.id))
  const polling = useAppSelector((state) => selectFormIsPolling(state, aiFeature.id))
  const executing = useAppSelector((state) => selectFormIsExecuting(state, aiFeature.id))
  const shouldPoll = useAppSelector((state) => selectShouldPollFormResultsForAiFeatureId(state, aiFeature.id))
  const clients = useAppSelector(selectUsersWithClientRole)
  const anonymousUsers = useAppSelector(selectAnonymousUsers)

  useEffect(() => {
    if (shouldPoll) {
      dispatch(startFormPolling(aiFeature.id))
    } else {
      dispatch(stopFormPolling(aiFeature.id))
      dispatch(formExecuteFinished(aiFeature.id))
    }
  }, [dispatch, shouldPoll, aiFeature])

  const [collapsed, setCollapsed] = useState<boolean>(false)

  const formName = scorecard?.name ?? 'Unknown form'

  if (!scorecard?.descriptor?.properties) {
    return null
  }

  const isUserLevelWithoutClientRoles = scorecard.config.userLevel && !clients.length && !anonymousUsers.length
  return (
    <Container
      className={classNames('result-card-container d-flex flex-column w-100 mw-100 my-2', {
        'py-3': !collapsed,
        'pt-3': collapsed,
      })}
    >
      <Row className='px-2'>
        <Col className='cursor-pointer' onClick={() => setCollapsed(!collapsed)}>
          <h5>{formName}</h5>
        </Col>
        <Col className='result-card-buttons-container d-flex justify-content-end'>
          <HeaderResultOptionsButton resultOptions={headerResultOptions} disabled={polling || executing} />
        </Col>
      </Row>
      <Row className='d-flex p-4'>
        {polling || executing ? (
          <LoadingResult />
        ) : !isUserLevelWithoutClientRoles ? (
          <FormResultView aiFeature={aiFeature} collapsed={collapsed} />
        ) : (
          <div className='paragraph-medium-extended zocks-text-gray-500 py-1 pe-4 ps-4'>No client found on the meeting</div>
        )}
      </Row>
    </Container>
  )
}
